<template>
  <div id="topdf" ref="pdfReport" class="all-img pdfReport">
      <div class="pdfPage" v-for="item in reportData" :key="item.url">
        <img :src="item" alt="">
      </div>
      <div v-if="noProduct" class="dietary">
        <div class="report-text">
          <div class="p4">Sorry, we are working hard to develop a product that meets your needs. Please stay tuned to us! </div>
        </div>
      </div>
      <div class="pdfPage">
        <img src="@/assets/pdfImg/FFQS0317-05.jpg" alt="">
      </div>
      <div class="dietary" v-for="(item, index) in suggestItem" :key="index">
        <div class="report-text">
          <div class="p1">DIATERY SUGGESTION</div>
          <div>
            <div class="p2" v-html="item[0].title"></div>
            <div class="p3" v-html="item[0].article"></div>
            <div class="p2" v-html="item[1] && item[1].title"></div>
            <div class="p3" v-html="item[1] && item[1].article"></div>
          </div>
        </div>
      </div>
      <div class="pdfPage">
        <img src="@/assets/pdfImg/FFQS0317-07.jpeg" alt="">
      </div>
      <div class="dietary" v-for="item in remindItem" :key="item[0]">
        <div class="report-text">
          <div class="p1">SPECIAL REMINDER</div>
          <div class="p3" v-html="item[0]"></div>
          <div class="p3" v-html="item[1]"></div>
        </div>
      </div>
  </div>
</template>

<script>
import dietary from '../../mixins/dietarySugeests'
import specialRemind from '../../mixins/specialRemind'
export default {
  mixins: [ dietary, specialRemind ],
  data () {
    return {
      reportData: [
        require("@/assets/pdfImg/FFQS0317-01.jpg"),
        require("@/assets/pdfImg/FFQS0317-02.jpg"),
        require("@/assets/pdfImg/FFQS0317-03.jpg"),
      ],
      noProduct: '',
      suggests: [],
      suggestItem: [],
      reminds: [],
      remindItem: []
    }
  },
  mounted () {
    while (this.reminds.length) {
      let arr = []
      let langText = []
      for (let i = 0; i < 2; i++) {
        if ( this.reminds[0] && this.reminds[0].substr(0, 1) == '*' ) {
          this.reminds[0] = this.reminds[0].substr(1)
          langText = [ this.reminds.shift() ]
          break
        }
        arr.push(this.reminds.shift())
      }
      arr.length && this.remindItem.push(arr)
      langText.length && this.remindItem.push(langText)
    }
    while (this.suggests.length) {
      let arr = []
      let langText = []
      for (let i = 0; i < 2; i++) {
        if ( this.suggests[0] && this.suggests[0].title.substr(0, 1) == '*' ) {
          this.suggests[0].title = this.suggests[0].title.substr(1)
          langText = [ this.suggests.shift() ]
          break
        }
        arr.push(this.suggests.shift())
      }
      arr.length && this.suggestItem.push(arr)
      langText.length && this.suggestItem.push(langText)
    }
    const ProductMap = {
      'FM-INSI-101': require("../../assets/pdfImg/Inositol.jpg"),
      'FM-PREVI-101': require("../../assets/pdfImg/Prenatal Vitamin.jpg"),
      'FM-DIM-101': require("../../assets/pdfImg/DIM.jpg"),
      'FM-EPOIL-101': require("../../assets/pdfImg/Evening Primrose Oil.jpg"),
      'FM-POSVI-101': require("../../assets/pdfImg/Postnatal Multivitamin.jpg"),
      'FM-CRANB-101': require("../../assets/pdfImg/Cranberry Concentrate.jpg"),
      'FM-ELDER-101': require("../../assets/pdfImg/Elderberry.jpg"),
      'FM-MCPEP-101': require("../../assets/pdfImg/Marine Collagen Peptides.jpg"),
      'FM-VCOLB-101': require("../../assets/pdfImg/Vegan Collagen Booster.jpg"),
      'FM-WMV-101': require("../../assets/pdfImg/Women’s Multivitamin.jpg"),
      'FM-PROBI-101': require("../../assets/pdfImg/Women’s Probiotic.jpg")
    }
    this.$store.state.product.forEach(msku => {
      this.reportData.push(ProductMap[msku])
    })
    if (this.$store.state.product.length === 0) {
      this.noProduct = true
    } else {
      this.noProduct = false
    }
    // this.reportData.push(require("@/assets/pdfImg/FFQS0317-05.jpg"))
    setTimeout(() => {
      this.$PDFSave(this.$refs.pdfReport, "Fememoter Health Report");
      this.$router.back()
    });
  }
}
</script>

<style lang="less" scoped>
@pdfWidth: 1000px;
.p4 {
  // height: 100%;
  padding: 200px 0;
  // padding-bottom: 21px;
  font-size: 35px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #000000;
  line-height: 48px;
}
.all-img{
    width: @pdfWidth;
    // height: 7444px;
    img {
      width: 100%;
      height: 1421px;
    }
    .report-text {
      padding-top: 150px;
      padding-left: 100px;
      padding-right: 100px;
    }
    .remind {
      // width: 757px;
      // height: 462px;
      padding-top: 14px;
      padding-bottom: 40px;
      font-size: 24px;
      font-family: Helvetica-Light, Helvetica;
      font-weight: 300;
      color: #000000;
      line-height: 36px;
    }
    .dietary {
      background-image: url("../../assets/pdfImg/FFQS0317-06.jpg");
      background-size: 100%, 100%;
      width: 100%;
      height: 1421px;
      .p1 {
        // width: 528px;
        height: 64px;
        // padding-bottom: 21px;
        font-size: 35px;
        font-family: Helvetica-Bold, Helvetica;
        font-weight: bold;
        color: #000000;
        line-height: 48px;
      }
      .p2 {
        width: 100%;
        // height: 34px;
        padding-top: 15px;
        // white-space:normal;
        font-size: 30px;
        font-family: Helvetica;
        color: #000000;
        line-height: 36px;
      }
      .p3 {
        // width: 718px;
        height: 550px;
        padding-top: 13px;
        padding-bottom: 17px;
        // white-space:normal;
        font-size: 19px;
        font-family: Helvetica-Light, Helvetica;
        font-weight: 300;
        color: #000000;
        line-height: 34px;
      }
    }
}
</style>